import Vuex, { Store } from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate';
import send from './send/index';
import login from './login/index';
import app from './app/index';
import register from './register/index';
import calculate from './calculate/index';
import order from './order/index';
import home from './home/index';

const dataState = createPersistedState({
  storage: window.localStorage,
  key: '_moving-kite',
  paths: ['calculate'],
});
const dataHomeState = createPersistedState({
  storage: window.localStorage,
  key: '_home-state',
  paths: ['home'],
});

Vue.use(Vuex);

const store = new Store({
  modules: {
    send,
    login,
    app,
    register,
    calculate,
    order,
    home,
  },
  plugins: [dataState, dataHomeState],
  getters: {
    app: () => {
      return app.state;
    },
  },
});

export default store;
